import styled from '@emotion/styled'

/* const StyledTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 400;
  border-bottom: 1px solid ${(props) => props.theme.colors.black};
  margin: 2rem 0 1rem 0;
`

const ChartTitle = ({ text }) => {
  return (
    <>
      <StyledTitle>{text}</StyledTitle>
    </>
  )
} */

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0 1rem 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.black};
`

const TitleText = styled.div`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: ${(props) => props.theme.fontSizes[2]};
  font-weight: 400;
`

const ChartTitle = ({ text, children }) => {
  return (
    <HeaderRow>
      <TitleText>{text}</TitleText>
      {children}
    </HeaderRow>
  )
}

export default ChartTitle
